import axios from "axios";

const AddOffer = (auth, obj) => {
  return axios.post("offers/add", obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const GetOffers = (auth) => {
  return axios.get("offers/getoffers", {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const Reject = (auth, id) => {
  return axios.delete(`offers/${id}`, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
const EditOffer = (auth, obj) => {
  return axios.put(`offers/edit/`, obj, {
    headers: {
      "x-auth-token": auth,
    },
  });
};
export { AddOffer, GetOffers, Reject, EditOffer };
